export class ImpuestoFilter {
   nombre: string;
   activo: boolean;
   isRetencion: boolean;
}
